module.exports = __webpack_public_path__ + "img/sample_check.77e8cba1.png";